import { Injectable, ErrorHandler, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoggingService } from '../../shared/services/logging.service';
import { NotificationService } from '../../shared/services/notification.service';
import { isEmptyError } from '../services/service.helpers';


@Injectable()
export class ErrorHandlerService extends ErrorHandler {
    private _loggingService = inject(LoggingService);
    private _notificationService = inject(NotificationService);
    private _translate = inject(TranslateService);



    constructor() {
        super();
    }

    handleError(error: Error) {
        if ((error as any)?.code === 4002) {
            // NG04002: stale/malformed URL with an unrecognised outlet path (e.g. old bookmarks).
            // The NavigationError handler in AppComponent redirects to root; nothing to surface here.
            return;
        }
        if (isEmptyError(error)) {
            // EmptyError occurs when the MsalInterceptor's inProgress$ observable completes
            // during a login redirect (e.g. token expiry). The page is about to reload, so
            // there is nothing actionable to show the user.
            console.warn('Suppressed EmptyError (likely MSAL redirect in progress):', error);
            return;
        }
        this._loggingService.logException(error);
        console.error(error);
        this._notificationService.openError(this._translate.instant('Something went wrong') +': ' + error.message);
    }
}
